import React, { useState, useEffect } from "react";
import { db, storage } from "../../utils/firebase";
import { collection, getDocs, doc, updateDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import Navbar from "../navbar/Navbar";
import Footer from "../footer/Footer";
import './AdminUsers.css';
import { Link, useLocation } from 'react-router-dom';

const ExploreAboutAdmin = () => {
  const [data, setData] = useState([]);
  const [images, setImages] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [editedData, setEditedData] = useState({});
  const [editedImages, setEditedImages] = useState([]);
  const location = useLocation();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'explore_about_bacoor'));
        const fetchedData = [];

        querySnapshot.forEach((doc) => {
          fetchedData.push({ id: doc.id, ...doc.data() });
        });

        setData(fetchedData);
        fetchImages(fetchedData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const fetchImages = async (fetchedData) => {
    try {
      const imageUrls = await Promise.all(
        fetchedData.map(async (row) => {
          const imagePromises = [1, 2, 3].map(async (num) => {
            const fileName = `${num}${row.id}.jpg`;
            const imageRef = ref(storage, `exploreabout/${fileName}`);
            return getDownloadURL(imageRef);
          });

          const rowImages = await Promise.all(imagePromises);
          return { id: row.id, images: rowImages };
        })
      );

      const imageData = fetchedData.map((row) => {
        const rowImages = imageUrls.find((imgData) => imgData.id === row.id);
        return rowImages ? rowImages.images : [];
      });

      setImages(imageData);
    } catch (error) {
      console.error("Error fetching images:", error);
    }
  };

  const handleEditToggle = (rowId) => {
    if (editingId === rowId) {
      setEditingId(null);
      setEditedData({});
      setEditedImages([]);
    } else {
      setEditingId(rowId);
      const row = data.find((row) => row.id === rowId);
      setEditedData({ ...row });
      setEditedImages([]); // Reset edited images
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedData({ ...editedData, [name]: value });
  };

  const handleImageChange = (e, index) => {
    const file = e.target.files[0];
    const updatedImages = [...editedImages];
    updatedImages[index] = file;
    setEditedImages(updatedImages);
  };

  const handleSave = async (rowId) => {
    try {
      const docRef = doc(db, 'explore_about_bacoor', rowId);
      await updateDoc(docRef, editedData);

      await Promise.all(
        editedImages.map((image, index) => {
          if (image) {
            const fileName = `${index + 1}${rowId}.jpg`;
            const imageRef = ref(storage, `exploreabout/${fileName}`);
            return uploadBytes(imageRef, image).then(() => getDownloadURL(imageRef));
          }
          return Promise.resolve();
        })
      );

      setEditingId(null);
      setEditedData({});
      setEditedImages([]);
    } catch (error) {
      console.error("Error saving changes:", error);
    }
  };

  const handleCancel = () => {
    setEditingId(null);
    setEditedData({});
    setEditedImages([]);
  };

  return (
    <div className="admin-page">
      <Navbar />
      <div className="admin-container">
        <div className="admin-sidebar">
           <h2>Admin Panel</h2>
           <Link to="/adminusers" className={`sidebar-button ${location.pathname === '/adminusers' ? 'active' : ''}`}>Users</Link>
           <Link to="/adminposts" className={`sidebar-button ${location.pathname === '/adminposts' ? 'active' : ''}`}>User Posts</Link>
           <Link to="/adminfeedback" className={`sidebar-button ${location.pathname === '/adminfeedback' ? 'active' : ''}`}>User Feedback</Link>
           <Link to="/announcementadmin" className={`sidebar-button ${location.pathname === '/announcementadmin' ? 'active' : ''}`}>Announcements</Link>
           <Link to="/exploreaboutadmin" className={`sidebar-button ${location.pathname === '/exploreaboutadmin' ? 'active' : ''}`}>Explore about Bacoor</Link>
 
           <h2>Places to Visit</h2>
           <Link to="/bridgesadmin" className={`sidebar-button ${location.pathname === '/bridgesadmin' ? 'active' : ''}`}>Bridges & Dams</Link>
           <Link to="/monumentsadmin" className={`sidebar-button ${location.pathname === '/monumentsadmin' ? 'active' : ''}`}>Monuments & Statues</Link>
           <Link to="/houseadmin" className={`sidebar-button ${location.pathname === '/houseadmin' ? 'active' : ''}`}>Ancestral Houses</Link>
           <Link to="/churchesadmin" className={`sidebar-button ${location.pathname === '/churchesadmin' ? 'active' : ''}`}>Churches & Religious Sites</Link>
 
           <h2>Things to Do</h2>
           <Link to="/recreationaladmin" className={`sidebar-button ${location.pathname === '/recreationaladmin' ? 'active' : ''}`}>Recreational Activities</Link>
           <Link to="/diningadmin" className={`sidebar-button ${location.pathname === '/diningadmin' ? 'active' : ''}`}>Dining and Culinary</Link>
           <Link to="/shoppingadmin" className={`sidebar-button ${location.pathname === '/shoppingadmin' ? 'active' : ''}`}>Shopping and Market</Link>
 
           <h2>Archives</h2>
           <Link to="/userarchive" className={`sidebar-button ${location.pathname === '/userarchive' ? 'active' : ''}`}>Users</Link>
           <Link to="/postsarchive" className={`sidebar-button ${location.pathname === '/postsarchive' ? 'active' : ''}`}>Posts</Link>
           <Link to="/feedbackarchive" className={`sidebar-button ${location.pathname === '/feedbackarchive' ? 'active' : ''}`}>Feedback</Link>
           <Link to="/announcementarchive" className={`sidebar-button ${location.pathname === '/announcementarchive' ? 'active' : ''}`}>Announcements</Link>
         </div>

        <div className="admin-content">
          <h2>About Bacoor Management</h2>
          <div className="table-container">
            {data.length > 0 ? (
              <table className="about-table">
                <thead>
                  <tr>
                    <th>Title 1</th>
                    <th>Description 1</th>
                    <th>Description 2</th>
                    <th>Image 1</th>
                    <th>Title 2</th>
                    <th>Description 3</th>
                    <th>Description 4</th>
                    <th>Image 2</th>
                    <th>Title 3</th>
                    <th>Description 5</th>
                    <th>Description 6</th>
                    <th>Image 3</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((row, index) => (
                    <tr key={row.id}>
                      <td>
                        {editingId === row.id ? (
                          <input
                            type="text"
                            name="title_1"
                            value={editedData.title_1}
                            onChange={handleInputChange}
                          />
                        ) : (
                          <h3>{row.title_1}</h3>
                        )}
                      </td>
                      <td>
                        {editingId === row.id ? (
                          <textarea
                            name="description_1"
                            value={editedData.description_1}
                            onChange={handleInputChange}
                          />
                        ) : (
                          <p>{row.description_1}</p>
                        )}
                      </td>
                      <td>
                        {editingId === row.id ? (
                          <textarea
                            name="description_2"
                            value={editedData.description_2}
                            onChange={handleInputChange}
                          />
                        ) : (
                          <p>{row.description_2}</p>
                        )}
                      </td>
                      <td>
                        {editingId === row.id ? (
                          <input
                            type="file"
                            onChange={(e) => handleImageChange(e, 0)}
                          />
                        ) : (
                          <img src={images[index]?.[0]} alt="Image 1" />
                        )}
                      </td>
                      <td>
                        {editingId === row.id ? (
                          <input
                            type="text"
                            name="title_2"
                            value={editedData.title_2}
                            onChange={handleInputChange}
                          />
                        ) : (
                          <h3>{row.title_2}</h3>
                        )}
                      </td>
                      <td>
                        {editingId === row.id ? (
                          <textarea
                            name="description_3"
                            value={editedData.description_3}
                            onChange={handleInputChange}
                          />
                        ) : (
                          <p>{row.description_3}</p>
                        )}
                      </td>
                      <td>
                        {editingId === row.id ? (
                          <textarea
                            name="description_4"
                            value={editedData.description_4}
                            onChange={handleInputChange}
                          />
                        ) : (
                          <p>{row.description_4}</p>
                        )}
                      </td>
                      <td>
                        {editingId === row.id ? (
                          <input
                            type="file"
                            onChange={(e) => handleImageChange(e, 1)}
                          />
                        ) : (
                          <img src={images[index]?.[1]} alt="Image 2" />
                        )}
                      </td>
                      <td>
                        {editingId === row.id ? (
                          <input
                            type="text"
                            name="title_3"
                            value={editedData.title_3}
                            onChange={handleInputChange}
                          />
                        ) : (
                          <h3>{row.title_3}</h3>
                        )}
                      </td>
                      <td>
                        {editingId === row.id ? (
                          <textarea
                            name="description_5"
                            value={editedData.description_5}
                            onChange={handleInputChange}
                          />
                        ) : (
                          <p>{row.description_5}</p>
                        )}
                      </td>
                      <td>
                        {editingId === row.id ? (
                          <textarea
                            name="description_6"
                            value={editedData.description_6}
                            onChange={handleInputChange}
                          />
                        ) : (
                          <p>{row.description_6}</p>
                        )}
                      </td>
                      <td>
                        {editingId === row.id ? (
                          <input
                            type="file"
                            onChange={(e) => handleImageChange(e, 2)}
                          />
                        ) : (
                          <img src={images[index]?.[2]} alt="Image 3" />
                        )}
                      </td>
                        <td>
                    {editingId === row.id ? (
                      <>
                        <button
                          className="save-btn btn btn-success"
                          onClick={() => handleSave(row.id)}
                        >
                          <i className="bi bi-check"></i>
                        </button>
                        <button
                          className="cancel-btn btn btn-secondary"
                          onClick={handleCancel}
                        >
                          <i className="bi bi-x"></i>
                        </button>
                      </>
                    ) : (
                      <button
                        className="edit-btn btn btn-primary"
                        onClick={() => handleEditToggle(row.id)}
                      >
                        <i className="bi bi-pencil"></i>
                      </button>
                    )}
                  </td>

                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p>Loading data...</p>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ExploreAboutAdmin;
